// extracted by mini-css-extract-plugin
module.exports = {"image":"AppErrorFullScreen_image__MqNrA","root":"AppErrorFullScreen_root__YWj__"};